import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Receipt, AlertTriangle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { RequestRow } from "@/pages/Requests";

export default function PaymentsPage() {
  const { t, lang, demoUser } = useApp();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/payments").then((r) => setData(r.data)).catch(() => setData({ payments: [], due: [] })); }, [demoUser]);
  return (
    <div className="space-y-5 px-4 pt-4" data-testid="payments-page">
      <h1 className="text-2xl font-bold">{t("payments")}</h1>
      <p className="rounded-xl bg-[hsl(var(--gold-soft))] p-3 text-xs">{t("paymentSimulated")}</p>
      <section>
        <h2 className="mb-2 flex items-center gap-2 text-base font-bold"><AlertTriangle size={16} className="text-[#B8901F]" /> {t("due")}</h2>
        <div className="space-y-2" data-testid="payments-due-list">
          {data?.due.length === 0 && <p className="text-sm text-muted-foreground">—</p>}
          {data?.due.map((r) => <RequestRow key={r.ref} r={r} />)}
        </div>
      </section>
      <section>
        <h2 className="mb-2 flex items-center gap-2 text-base font-bold"><Receipt size={16} /> {t("paid")}</h2>
        <div className="space-y-2" data-testid="payments-history-list">
          {!data && <div className="h-16 animate-pulse rounded-xl bg-muted" />}
          {data?.payments.length === 0 && <p className="text-sm text-muted-foreground">{t("noPayments")}</p>}
          {data?.payments.map((p) => (
            <Link key={p.txn_id} to={`/requests/${p.ref}`} data-testid={`payment-row-${p.txn_id}`} className="flex items-center justify-between gap-3 rounded-xl border bg-card p-3 shadow-sm">
              <span className="min-w-0">
                <span className="block truncate text-sm font-semibold">{lang === "ar" ? p.name_ar : p.name_en}</span>
                <span className="text-[11px] text-muted-foreground">{p.method} · {p.masked_ref} · {new Date(p.at).toLocaleDateString()}</span>
              </span>
              <span className="shrink-0 text-end">
                <span className="block text-sm font-bold">{p.amount_qar} QAR</span>
                <span className="text-[11px] font-semibold text-[#0F5132] dark:text-emerald-400">✓ {p.status}</span>
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
